export default __webpack_public_path__ + "static/media/533.0d31d076.gif";